import { putAction, postAction } from '../http'

export default {
    add(params = {}) {
        return postAction('/api/feature/projectLike/add', params);
    },
    edit(params = {}) {
        return putAction('/api/feature/projectLike/edit', params);
    }
}